<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar class="mb-2"></medsurf-navbar>
  
  <!-- Medsurf Control Search -->
  <medsurf-control-search class="overflow-hidden mb-2"></medsurf-control-search>
</div>

